import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './PaymentRemove.css';
import { Farecard, PaymentMethod } from '../../services/types/apitypes';

type PaymentRemoveProps = {
  goBack: () => void;
  remove: (p: PaymentMethod) => void;
  payment: PaymentMethod;
};

export default function PaymentRemove({
  goBack,
  payment,
  remove,
}: PaymentRemoveProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <div className="ion-text-center">
        <IonIcon
          className="payment-remove-circle"
          src="assets/icon/card-remove-circle.svg"
        ></IonIcon>
      </div>

      <h1 className="h1 pt-2 ion-text-center">{t('payments.remove')}</h1>
      <p className="pt-1 instructions ion-text-center">
        {t('payments.removeinstruction')}
      </p>

      <div className="pt-5 ion-text-center">
        <IonButton
          className="btn-default "
          expand="block"
          onClick={() => remove(payment)}
        >
          {t('payments.remove')}
        </IonButton>
      </div>
      <div className="ion-text-center">
        <IonButton
          onClick={goBack}
          fill="outline"
          expand="block"
          className="btn-default"
        >
          {t('home.cancel')}
        </IonButton>
      </div>
    </>
  );
}
